import React from "react"

import { Box, TextField } from "@mui/material"

import Loading from "../../../Loading"
import useNotification from "../../../Notification"

import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"

import api from "../../../../api"

import { getSession, saveSession } from "../../../../auth"

class WhatsAppVoiceMessage extends React.Component {

	constructor(props) {
		super(props)

		const settings = getSession().profile.enterprise.settings

		this.state = {
			loading    : false,
			callAutMsg : settings.wa_call_aut_msg,
			callInvMsg : settings.wa_call_inv_msg
		}
	}

	updateConfig = async () => {
		const session = getSession()
		const enterpriseId = session.profile.enterprise.id
		
		this.setState({ loading: true })
		const response = await api.patch(`api/enterprises/${enterpriseId}/`, {
			settings: {
				wa_call_aut_msg: this.state.callAutMsg,
				wa_call_inv_msg: this.state.callInvMsg,	
			}
		})
		this.setState({ loading: false })
		
		if (response.status === 200) {
			session.profile.enterprise.settings.wa_call_aut_msg = this.state.callAutMsg
			session.profile.enterprise.settings.wa_call_inv_msg = this.state.callInvMsg
			saveSession(session)
			useNotification("Sucesso!", "Configurações alteradas com sucesso.", "success")
			return
		}
		
		useNotification("Ops!", "Algo deu errado, tente novamente.", "danger")
	}

	render() {
		return (
			<>
				<Loading loading={this.state.loading} />
				{! this.state.loading &&
					<Box className="input-settings">
						<Box sx={{ flex: .8, display:"flex", flexDirection:"column", gap:"1rem" }}>
							<Box className="category-title">
								Mensagem de autorização
							</Box>
							<TextField
								size="small"
								label="Mensagem"
								fullWidth
								type="text"
								variant="outlined"
								value={this.state.callAutMsg}
								onChange={(event) => this.setState({ callAutMsg: event.target.value })}
							/>
							<Box className="category-title">
								Mensagem de convite (operador)
							</Box>
							<TextField
								size="small"
								label="Mensagem"
								fullWidth
								type="text"
								variant="outlined"
								className="push-bottom"
								value={this.state.callInvMsg}
								onChange={(event) => this.setState({ callInvMsg: event.target.value })}
							/>
							<Box>
								<LoadingButton
									onClick={() => this.updateConfig()}
									loading={this.state.loading}
									loadingPosition="start"
									startIcon={<SaveIcon />}
									variant="contained"
								>
									Salvar
								</LoadingButton>
							</Box>
						</Box>
					</Box>
				}
			</>
		)
	}
}

export default WhatsAppVoiceMessage
